import FemaleIcon from '@/assets/female.svg?react';
import MaleIcon from '@/assets/male.svg?react';

import { LayoutDataType } from '../../types';

export const GENDER_OPTIONS: {
  id: LayoutDataType['gender'];
  name: string;
  subtitle: string;
  Icon: React.FC;
}[] = [
  {
    id: 'female',
    name: 'Lira Voss',
    subtitle: 'Forest warrior',
    Icon: FemaleIcon,
  },
  {
    id: 'male',
    name: 'Thorne',
    subtitle: 'Mystical soul',
    Icon: MaleIcon,
  },
];
